export type TransitionDirection = "left" | "right" | null;

let currentDirection: TransitionDirection = null;

/**
 * Set the transition direction. Call immediately before programmatic
 * navigation so that AnimatedOutlet reads it during the same render cycle.
 */
export function setTransitionDirection(dir: TransitionDirection): void {
  currentDirection = dir;
}

/**
 * Read and consume the current direction. Returns the direction
 * and resets to null so subsequent non-swipe navigations use the
 * default fade animation.
 */
export function consumeTransitionDirection(): TransitionDirection {
  const dir = currentDirection;
  currentDirection = null;
  return dir;
}
